<div class="fuse-card auto-width mb-12 mat-card mat-elevation-z2" [ngClass.gt-sm]="'mb-0 m-b-6'">

    <!-- WIDGET 1 -->
    <fuse-widget class="widget p-0" fxLayout="column" fxFlex="100" fxFlex.gt-xs="100" fxFlex.gt-md="100">

        <!-- Front -->

        <div class="fuse-widget-front no-border">
            <div class="pl-16 pr-8 py-16 h-52 m-5px" fxLayout="row" fxLayoutAlign="space-between center">
                <div class="h3 cardHeader">Bajas activas</div>

                <!-- <button mat-icon-button class="fuse-widget-flip-button" aria-label="more">
                    <mat-icon>search</mat-icon>
                </button> -->
            </div>

            <div class="pt-0 p-16" fxLayout="column" fxLayoutAlign="center center"
                *ngIf="agendaService.isLoading4 == false">
                <div class="light-blue-fg font-size-36 line-height-36">

                    {{(agendaService.bajasActivasCount !=null ? agendaService.bajasActivasCount : null ) | decimalPoint}}
                </div>
            </div>
            <div *ngIf="agendaService.isLoading4 == true" class="m-auto">
                <mat-progress-spinner class="m-auto" [diameter]="50" color="primary" mode="indeterminate">
                </mat-progress-spinner>
            </div>
        </div>
        <!-- / Front -->

        <!-- Back -->
        <!-- <div class="fuse-widget-back p-16 no-border">
            <button mat-icon-button class="fuse-widget-flip-button" aria-label="Flip widget">
                <mat-icon class="s-16">close</mat-icon>
            </button>

            <div>
                Detail
            </div>
        </div> -->
        <!-- / Back -->

    </fuse-widget>
    <!-- / WIDGET 1 -->
</div>

<div class="fuse-card auto-width mb-12 mat-card mat-elevation-z2" [ngClass.gt-sm]="'mb-0 m-b-6'">

    <!-- WIDGET 2 -->
    <fuse-widget class="widget p-0" fxLayout="column" fxFlex="100" fxFlex.gt-xs="100" fxFlex.gt-md="100">

        <!-- Front -->

        <div class="fuse-widget-front no-border">
            <div class="pl-16 pr-8 py-16 h-52 m-5px" fxLayout="row" fxLayoutAlign="space-between center">
                <div class="h3 cardHeader">Tareas hoy</div>
                <!-- <button mat-menu-item [routerLink]="['/create-actuation/visit',this.actuationService.CurrentLeaveId,actuationOperation.Visita]">Visita</button> -->
                <button mat-icon-button class="fuse-widget-flip-button" aria-label="more" (click)="NavigateToTaskSelection()">
                    <mat-icon>search</mat-icon>
                </button>
            </div>

            <div class="pt-0 p-16" fxLayout="column" fxLayoutAlign="center center"
                *ngIf="agendaService.isLoading2 == false">
                <div class="orange-fg font-size-36 line-height-36">
                    {{(todaytaskCount != null ? todaytaskCount : null) | decimalPoint}}
                </div>
            </div>
            <div *ngIf="agendaService.isLoading2 == true" class="m-auto">
                <mat-progress-spinner class="m-auto" [diameter]="50" color="primary" mode="indeterminate">
                </mat-progress-spinner>
            </div>
        </div>
        <!-- / Front -->

        <!-- Back -->
        <!-- <div class="fuse-widget-back p-16 no-border">
            <button mat-icon-button fuseWidgetToggle class="fuse-widget-flip-button" aria-label="Flip widget">
                <mat-icon class="s-16">close</mat-icon>
            </button>

            <div>
                Detail
            </div>
        </div> -->
        <!-- / Back -->

    </fuse-widget>
    <!-- / WIDGET 2 -->
</div>

<div class="fuse-card auto-width mb-12 mat-card mat-elevation-z2" [ngClass.gt-sm]="'mb-0 m-b-6'">

    <!-- WIDGET 3 -->
    <fuse-widget class="widget p-0" fxLayout="column" fxFlex="100" fxFlex.gt-xs="100" fxFlex.gt-md="100">

        <!-- Front -->

        <div class="fuse-widget-front no-border">
            <div class="pl-16 pr-8 py-16 h-52 m-5px" fxLayout="row" fxLayoutAlign="space-between center">
                <div class="h3 cardHeader">Actuaciones</div>

                <!-- <button mat-icon-button class="fuse-widget-flip-button" aria-label="more">
                    <mat-icon>search</mat-icon>
                </button> -->
            </div>

            <div class="pt-0 p-16" fxLayout="column" fxLayoutAlign="center center"
                *ngIf="agendaService.isLoading1 == false">
                <div class="blue-grey-fg font-size-36 line-height-36">
                       
                    {{(todayActuacionCount != null ? todayActuacionCount : null ) | decimalPoint }}
                </div>
            </div>

            <div *ngIf="agendaService.isLoading1 == true" class="m-auto">
                <mat-progress-spinner class="m-auto" [diameter]="50" color="primary" mode="indeterminate">
                </mat-progress-spinner>
            </div>
            <!-- <div class="p-16 border-top" fxLayout="row" fxLayoutAlign="start center">
                        <span class="h4 secondary-text text-truncate">
                            Label
                        </span>
                        <span class="h4 ml-8">count</span>
                    </div> -->
        </div>
        <!-- / Front -->

        <!-- Back -->
        <!-- <div class="fuse-widget-back p-16 no-border">
            <button mat-icon-button fuseWidgetToggle class="fuse-widget-flip-button" aria-label="Flip widget">
                <mat-icon class="s-16">close</mat-icon>
            </button>

            <div>
                Detail
            </div>
        </div> -->
        <!-- / Back -->

    </fuse-widget>
    <!-- / WIDGET 3 -->

</div>